import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Container, Divider } from "@mui/material";
import styles from "../../styles/common/sideSectionFrame.module.css";

type SideSectionProps = {
  leftSection: JSX.Element | JSX.Element[];
  rightSection: JSX.Element | JSX.Element[];
};

const SideSectionFrame = (props: SideSectionProps) => {
  return (
    <>
      <Box>
        <Grid container direction="row" paddingBottom={"60px"}>
          <Grid item container xl={3} lg={4} md={5} sm={12} xs={12}>
            <Container className={styles.leftContainer}>
              {props.leftSection}
            </Container>
          </Grid>

          <Grid
            item
            md={0.05}
            xl={0.05}
            sx={{ display: { xs: "none", sm: "none", md: "flex" } }}
          >
            <Divider orientation="vertical" className={styles.divider_v} />
          </Grid>

          {/* <Grid item sx={{ display: { md: "none" } }} xs={12}>
            <Divider
              className={styles.divider_h}
              orientation="horizontal"
            ></Divider>
          </Grid> */}

          <Grid
            item
            container
            xs={12}
            xl={8.95}
            lg={7.95}
            md={6.95}
            sm={12}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Container sx={{ minWidth: "95%" }}>{props.rightSection}</Container>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default SideSectionFrame;
